import { Grid } from "@mui/material";
import FormFields from "components/UI/FormFields/FormFields";
import { InputTypes } from "constants/enums";
import { IFormField } from "models/app";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface Props {
  onChangeFrom: (date: Date) => void;
  onChangeTo: (date: Date) => void;
  valueFrom: any;
  valueTo: any;
}

const Filters: React.FC<Props> = ({
  onChangeFrom,
  onChangeTo,
  valueFrom,
  valueTo,
}) => {
  const {
    control,
    watch,
    setValue,
    register,
    formState: { errors },
  } = useForm<any>({ mode: "onChange" });

  const { t, i18n } = useTranslation();

  let filterFields: IFormField[] = [
    {
      name: "Start_Date",
      label: t("T_start_date"),
      type: InputTypes.CALENDER,
      defaultValue: valueFrom,
      onChange: (value: Date) => {
        let date = new Date(value);
        // check if date is invalid
        onChangeFrom(date);
      },
    },
    {
      name: "End_Date",
      label: t("T_end_date"),
      type: InputTypes.CALENDER,
      defaultValue: valueTo,
      onChange: (value: Date) => {
        let date = new Date(value);
        onChangeTo(date);
      },
    },
  ];

  return (
    <Grid container spacing={1} mb={2}>
      {filterFields.map((field: any, index: number) => (
        <Grid item lg={3} md={6} xs={12} key={index}>
          <FormFields
            {...field}
            control={control}
            errors={errors}
            watch={watch}
            setValue={setValue}
            register={register}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default Filters;
